import { z } from 'zod/v4';
import { CompanyDocumentSchema } from './company-document.js';

export const ListSharedCompanyDocumentsQuerySchema = z.object({
  companyId: z.string().min(1),
});

export const ListSharedCompanyDocumentsResponseSchema = z.array(
  CompanyDocumentSchema,
);

export type ListSharedCompanyDocumentsQueryType = z.infer<
  typeof ListSharedCompanyDocumentsQuerySchema
>;
